import { useEvent } from "shared/lib/useEvent"

import { useNavigateToProject } from "entities/projects/model/useNavigateToProject"
import { useAcceptTeamInvitation } from "entities/team-invitations/api/useAcceptTeamInvitationMutation"
import { useDeclineTeamInvitation } from "entities/team-invitations/api/useDeclineTeamInvitationMutation"
import { useTeamInvitationListData } from "entities/team-invitations/model/useTeamInvitationListData"

import { ProjectTeamInvitationListModel } from "../types/ProjectTeamInvitationListModel"

export interface UseTeamInvitationListModelArgs {
  onNavigateToProject?: (args: { projectID: string }) => void
}

export function useTeamInvitationListModel(
  args?: UseTeamInvitationListModelArgs
): ProjectTeamInvitationListModel {
  const { onNavigateToProject } = args || {}
  const { teamInvitations, isLoading } = useTeamInvitationListData()
  const { acceptTeamInvitation } = useAcceptTeamInvitation()
  const { declineTeamInvitation } = useDeclineTeamInvitation()
  const navigateToProject = useNavigateToProject(null)

  const handleNavigateToProject = useEvent((id: string) => {
    onNavigateToProject?.({ projectID: id })
    navigateToProject({ id })
  })

  return {
    teamInvitations,
    isLoading,
    onReject: declineTeamInvitation,
    onAccept: acceptTeamInvitation,
    onNavigateToProject: handleNavigateToProject
  }
}
